module.exports = __webpack_public_path__ + "img/sup_cardsetting_banner.c0461e93.jpg";